import { makeAutoObservable } from 'mobx';
import { RootStore } from '../RootStore';

export class PopupStore {
  rootStore: RootStore;
  isNewHospitalOpen: boolean = false;
  isNewManuelRowOpen: boolean = false;
  isNewQrCodeRowOpen: boolean = false;
  isEditManuelRowOpen: boolean = false;
  isSwitchHospitalOpen: boolean = false;
  isQrCodeOriginalDataOpen: boolean = false;
  isDeleteConfirmationOpen: boolean = false;
  isNewKnRowOpen: boolean = false;
  isEditUserOpen: boolean = false; // User Management için eklendi
  isNewUserOpen: boolean = false; // User Management için eklendi
  isDeleteUserConfirmationOpen: boolean = false; // User Management için eklendi
  isNewTagOpen: boolean = false;
  isEditHospitalOpen: boolean = false; // Hastane düzenleme için eklendi
  isSelectTagsOpen: boolean = false; // Etiket seçimi için eklendi
  isFilesDialogOpen: boolean = false; // Dosyalar popup için eklendi
  isNewOvertimeOpen: boolean = false; // Mesai ekleme için eklendi
  isEditOvertimeOpen: boolean = false; // Mesai düzenleme için eklendi
  isDeleteOvertimeConfirmationOpen: boolean = false; // Mesai silme onayı için eklendi
  isNewLeaveOpen: boolean = false; // İzin ekleme için eklendi
  isRejectionReasonOpen: boolean = false; // Red sebebi için eklendi
  isNewExpenseOpen: boolean = false; // Harcama ekleme için eklendi
  isEditExpenseOpen: boolean = false; // Harcama düzenleme için eklendi
  isExpenseDetailOpen: boolean = false; // Harcama detay için eklendi
  isDeleteExpenseConfirmationOpen: boolean = false; // Harcama silme onayı için eklendi
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setIsNewHospitalOpen = (value: boolean) => {
    this.isNewHospitalOpen = value;
  };

  setIsNewManuelRowOpen = (value: boolean) => {
    this.isNewManuelRowOpen = value;
  };

  setIsNewQrCodeOpen = (value: boolean) => {
    this.isNewQrCodeRowOpen = value;
  };

  setIsEditManuelRowOpen = (value: boolean) => {
    this.isEditManuelRowOpen = value;
  };

  setIsSwitchHospitalOpen = (value: boolean) => {
    this.isSwitchHospitalOpen = value;
  };

  setIsQrCodeOriginalDataOpen = (value: boolean) => {
    this.isQrCodeOriginalDataOpen = value;
  };

  setIsDeleteConfirmationOpen = (value: boolean) => {
    this.isDeleteConfirmationOpen = value;
  };

  setIsNewKnRowOpen = (value: boolean) => {
    this.isNewKnRowOpen = value;
  };

  // User Management için eklenen metodlar
  setIsEditUserOpen = (value: boolean) => {
    this.isEditUserOpen = value;
  };

  setIsNewUserOpen = (value: boolean) => {
    this.isNewUserOpen = value;
  };

  setIsDeleteUserConfirmationOpen = (value: boolean) => {
    this.isDeleteUserConfirmationOpen = value;
  };
  setIsNewTagOpen = (value: boolean) => {
    this.isNewTagOpen = value;
  };
  setIsEditHospitalOpen = (value: boolean) => {
    this.isEditHospitalOpen = value;
  };

  setIsSelectTagsOpen = (value: boolean) => {
    this.isSelectTagsOpen = value;
  };

  setIsFilesDialogOpen = (value: boolean) => {
    this.isFilesDialogOpen = value;
  };

  // Mesai popup'ları için eklenen metodlar
  setIsNewOvertimeOpen = (value: boolean) => {
    this.isNewOvertimeOpen = value;
  };

  setIsEditOvertimeOpen = (value: boolean) => {
    this.isEditOvertimeOpen = value;
  };

  setIsDeleteOvertimeConfirmationOpen = (value: boolean) => {
    this.isDeleteOvertimeConfirmationOpen = value;
  };

  setIsNewLeaveOpen = (value: boolean) => {
    this.isNewLeaveOpen = value;
  };

  setIsRejectionReasonOpen = (value: boolean) => {
    this.isRejectionReasonOpen = value;
  };

  // Harcama popup'ları için eklenen metodlar
  setIsNewExpenseOpen = (value: boolean) => {
    this.isNewExpenseOpen = value;
  };

  setIsEditExpenseOpen = (value: boolean) => {
    this.isEditExpenseOpen = value;
  };

  setIsExpenseDetailOpen = (value: boolean) => {
    this.isExpenseDetailOpen = value;
  };

  setIsDeleteExpenseConfirmationOpen = (value: boolean) => {
    this.isDeleteExpenseConfirmationOpen = value;
  };
}
